export default __webpack_public_path__ + "static/media/740.eaed0452.png";